import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import * as Styles from './SplitPanel.module.scss';
export function SplitPanel(props) {
    var panelRef = React.useRef(null);
    var _a = React.useState(undefined), sidePanelWidth = _a[0], setSidePanelWidth = _a[1];
    var dragging = React.useRef(false);
    var startX = React.useRef(0);
    var startWidth = React.useRef(0);
    // Mouse events
    var onMouseDown = function (e) {
        var _a;
        dragging.current = true;
        startX.current = e.clientX;
        startWidth.current = ((_a = panelRef.current) === null || _a === void 0 ? void 0 : _a.firstElementChild) instanceof HTMLElement ? panelRef.current.firstElementChild.offsetWidth : 0;
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        e.preventDefault();
    };
    var onMouseMove = function (e) {
        if (!dragging.current)
            return;
        var dx = e.clientX - startX.current;
        setSidePanelWidth(Math.max(50, startWidth.current + dx));
    };
    var onMouseUp = function () {
        dragging.current = false;
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
    };
    // Touch events
    var onTouchStart = function (e) {
        var _a;
        dragging.current = true;
        startX.current = e.touches[0].clientX;
        startWidth.current = ((_a = panelRef.current) === null || _a === void 0 ? void 0 : _a.firstElementChild) instanceof HTMLElement ? panelRef.current.firstElementChild.offsetWidth : 0;
        document.addEventListener('touchmove', onTouchMove);
        document.addEventListener('touchend', onTouchEnd);
        e.preventDefault();
    };
    var onTouchMove = function (e) {
        if (!dragging.current)
            return;
        var dx = e.touches[0].clientX - startX.current;
        setSidePanelWidth(Math.max(50, startWidth.current + dx));
    };
    var onTouchEnd = function () {
        dragging.current = false;
        document.removeEventListener('touchmove', onTouchMove);
        document.removeEventListener('touchend', onTouchEnd);
    };
    // Clean up listeners on unmount
    React.useEffect(function () {
        return function () {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
            document.removeEventListener('touchmove', onTouchMove);
            document.removeEventListener('touchend', onTouchEnd);
        };
    }, []);
    // Set CSS variable for sidePanelWidth
    React.useEffect(function () {
        if (panelRef.current && sidePanelWidth) {
            panelRef.current.style.setProperty('--split-panel-side-width', "".concat(sidePanelWidth, "px"));
        }
        else if (panelRef.current) {
            panelRef.current.style.removeProperty('--split-panel-side-width');
        }
    }, [sidePanelWidth]);
    return (_jsxs("div", { ref: panelRef, className: Styles.splitPanelRoot, children: [_jsx("div", { className: Styles.sidePanel, children: props.sidePanel }), _jsx("div", { className: Styles.resizer, onMouseDown: onMouseDown, onTouchStart: onTouchStart, role: "separator", "aria-orientation": "vertical", tabIndex: 0, children: "======" }), _jsx("div", { children: props.children })] }));
}
